import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
type Props = {
  title: string;
  subtitle: string;
};
const Header = t0 => {
  const $ = _c(8);
  const {
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      mt: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography component="h1" variant="title">{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== subtitle) {
    t3 = <Typography variant="text">{subtitle}</Typography>;
    $[3] = subtitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Box sx={t1}>{t2}{t3}</Box>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default Header;